import PageContainer from '@/common/components/PageContainer'
import useQueryGetBrokeNotifications from '@/modules/client-setting/api/hooks/useQueryGetBrokeNotifications'
import BrokeNotificationListing from '@/modules/client-setting/components/BrokeNotification/components/BrokeNotificationListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function BrokeNotificationPage() {
	const { data, isLoading } = useQueryGetBrokeNotifications()

	return (
		<PageContainer>
			<BrokeNotificationListing data={data?.data || []} isLoading={isLoading} />
		</PageContainer>
	)
}

const GuardedBrokeNotificationPage = withUserPermission(BrokeNotificationPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.WEB_SETTING],
})

export default GuardedBrokeNotificationPage
